import { render, staticRenderFns } from "./NetworkParameterization.vue?vue&type=template&id=08fc3b1c&scoped=true&"
import script from "./NetworkParameterization.vue?vue&type=script&lang=js&"
export * from "./NetworkParameterization.vue?vue&type=script&lang=js&"
import style0 from "./NetworkParameterization.vue?vue&type=style&index=0&id=08fc3b1c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fc3b1c",
  null
  
)

export default component.exports